import { Stack, styled } from '@mui/material';
import * as React from 'react';

import { bodySmallSemiBold, colorSystem } from '../../../../theme';

export interface QuickPreset {
    id: string;
    label: string;
}

export interface QuickPresetsProps {
    presets: QuickPreset[];
    onPick: (id: string) => void;
    'aria-label'?: string;
    /** Fits the popover by default; pass `'0'` outside it. */
    padding?: string;
}

export function QuickPresets({
    presets,
    onPick,
    'aria-label': ariaLabel,
    padding = '8px 12px 0',
}: QuickPresetsProps): JSX.Element {
    return (
        <Row direction="row" spacing="6px" role="group" aria-label={ariaLabel} sx={{ padding }}>
            {presets.map((p) => (
                <Chip key={p.id} type="button" onClick={() => onPick(p.id)}>
                    {p.label}
                </Chip>
            ))}
        </Row>
    );
}

const Row = styled(Stack)({
    flexWrap: 'wrap',
    rowGap: '6px',
});

const Chip = styled('button')({
    ...bodySmallSemiBold,
    height: '24px',
    padding: '0 10px',
    borderRadius: '12px',
    border: `1px solid ${colorSystem.neutral[2]}`,
    background: colorSystem.neutral.white,
    color: colorSystem.neutral[8],
    cursor: 'pointer',
    transition: 'background 120ms ease, border-color 120ms ease, color 120ms ease',
    '&:hover': {
        background: colorSystem.primary[1],
        borderColor: colorSystem.primary[3],
        color: colorSystem.primary[7],
    },
});
